<template>
  <div class="ad-confirm-panel">
    <div class="confirm-layout">
      <div class="type-sider">
        <div
          v-for="item in tabs"
          :key="item.value"
          class="type-sider-item"
          :class="{ active: String(item.value) === String(activeTab) }"
          @click="$emit('update:activeTab', String(item.value))"
        >
          {{ item.tabLabel }}
        </div>
      </div>

      <div class="preview-col">
        <div class="preview-canvas" :class="previewClass">
          <template v-if="Number(activeTab) === 2">
            <div class="popup-mask">
              <div class="popup-card">
                <img
                  v-if="currentContent.imageUrl"
                  :src="currentContent.imageUrl"
                  alt="广告预览"
                >
                <div v-else class="preview-empty">暂无广告图</div>
              </div>
              <div class="popup-close">
                <a-icon type="close" />
              </div>
            </div>
          </template>
          <template v-else-if="currentContent.imageUrl">
            <img
              class="preview-image"
              :src="currentContent.imageUrl"
              alt="广告预览"
            >
          </template>
          <div v-else class="preview-empty">暂无广告图</div>
        </div>
      </div>

      <div class="page-col">
        <div class="section-title">广告展示页面</div>
        <div class="page-checkbox-row">
          <a-checkbox
            :indeterminate="indeterminate"
            :checked="checkAll"
            @change="onCheckAllChange"
          >
            全选
          </a-checkbox>
          <a-checkbox-group
            class="page-checkbox-group"
            :value="selectedPages"
            @change="onPagesChange"
          >
            <a-checkbox
              v-for="item in displayPageOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </a-checkbox>
          </a-checkbox-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export const DISPLAY_PAGE_OPTIONS = [
  { label: '首页', value: 1 },
  { label: '酒店频道页', value: 2 },
  { label: '酒店列表页', value: 3 },
  { label: '酒店详情页', value: 4 },
  { label: '支付完成页', value: 5 }
]

export default {
  name: 'AdvertisementConfirmPanel',
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    activeTab: {
      type: [String, Number],
      default: ''
    },
    contentMap: {
      type: Object,
      default: () => ({})
    },
    pageMap: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      displayPageOptions: DISPLAY_PAGE_OPTIONS
    }
  },
  computed: {
    currentContent() {
      const key = Number(this.activeTab)
      return this.contentMap[key] || this.contentMap[this.activeTab] || {}
    },
    selectedPages() {
      const key = Number(this.activeTab)
      return this.pageMap[key] || this.pageMap[this.activeTab] || []
    },
    checkAll() {
      return (
        this.displayPageOptions.length > 0 &&
        this.selectedPages.length === this.displayPageOptions.length
      )
    },
    indeterminate() {
      const len = this.selectedPages.length
      return len > 0 && len < this.displayPageOptions.length
    },
    previewClass() {
      const map = {
        1: 'is-splash',
        2: 'is-interstitial',
        3: 'is-banner-sm',
        4: 'is-banner-lg'
      }
      return map[Number(this.activeTab)] || ''
    }
  },
  methods: {
    emitPages(pages) {
      this.$emit('pages-change', {
        adType: Number(this.activeTab),
        pages: pages || []
      })
    },
    onPagesChange(checkedList) {
      this.emitPages(checkedList)
    },
    onCheckAllChange(e) {
      const checked = e.target.checked
      this.emitPages(
        checked ? this.displayPageOptions.map(item => item.value) : []
      )
    }
  }
}
</script>

<style scoped lang="less">
.ad-confirm-panel {
  .confirm-layout {
    display: flex;
    align-items: stretch;
    min-height: 420px;
    border: 1px solid #f0f0f0;
    background: #fff;
  }

  .type-sider {
    flex-shrink: 0;
    width: 180px;
    background: #fafafa;
    border-right: 1px solid #f0f0f0;
  }

  .type-sider-item {
    position: relative;
    padding: 14px 20px;
    color: rgba(0, 0, 0, 0.85);
    cursor: pointer;
    line-height: 1.4;
    transition: all 0.2s;

    &:hover {
      color: #1890ff;
    }

    &.active {
      color: #1890ff;
      background: #fff;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 3px;
        height: 100%;
        background: #1890ff;
      }
    }
  }

  .preview-col {
    flex-shrink: 0;
    width: 260px;
    padding: 0;
    background: #f5f5f5;
    border-right: 1px solid #f0f0f0;
  }

  .preview-canvas {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    min-height: 360px;
    overflow: hidden;
    background: #f5f5f5;

    &.is-splash {
      align-items: stretch;
      justify-content: stretch;

      .preview-image {
        width: 100%;
        height: 100%;
        min-height: 360px;
        object-fit: cover;
        border-radius: 0;
        background: #fff;
      }
    }

    &.is-banner-sm,
    &.is-banner-lg {
      padding: 24px 16px;

      .preview-image {
        width: 100%;
        max-height: 120px;
        object-fit: cover;
        border-radius: 4px;
        background: #fff;
      }
    }

    &.is-interstitial {
      padding: 0;
    }
  }

  .preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .preview-empty {
    color: rgba(0, 0, 0, 0.25);
    font-size: 13px;
  }

  .popup-mask {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    min-height: 360px;
    padding: 24px 16px;
    background: rgba(0, 0, 0, 0.35);
  }

  .popup-card {
    width: 100%;
    overflow: hidden;
    border-radius: 8px;
    background: #fff;

    img {
      display: block;
      width: 100%;
      max-height: 220px;
      object-fit: cover;
    }

    .preview-empty {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 160px;
    }
  }

  .popup-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    margin-top: 14px;
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.85);
    border-radius: 50%;
  }

  .page-col {
    flex: 1;
    min-width: 0;
    padding: 24px 28px;
    background: #fff;
  }

  .section-title {
    margin-bottom: 20px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    font-weight: 500;
  }

  .page-checkbox-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .page-checkbox-group {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .page-checkbox-row > .ant-checkbox-wrapper,
  .page-checkbox-group /deep/ .ant-checkbox-wrapper {
    margin: 0 24px 12px 0;
  }
}
</style>
